import React from "react";
import clsx from "clsx";
import useStyles from "./styles";

const CheckIcon = () => (
    <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="10" fill="#3555f4" />
        <path d="M6 10l3 3 5-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const XIcon = () => (
    <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="10" fill="#F05252" />
        <path d="M7 7l6 6M13 7l-6 6" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const PremiumLitePlanCard = ({
    tier = "lite",
    title,
    originalPrice,
    price,
    priceUnit = "/month",
    saveLabel,
    benefits = [],
    ctaLabel = "Choose This plan",
    onChoose,
    recommended = false,
    voucherCode,
    nextBilling,
    packageListVariant = false,
    language = "en",
}) => {
    const c = useStyles();
    const isCollabLite = packageListVariant && tier === "lite";
    const shouldUsePrimaryCta = recommended || isCollabLite || tier === "lite";
    const appliedLabel = language === "id"
        ? `Kode ${voucherCode} diterapkan`
        : `${voucherCode} code applied`;
    const titleContent = Array.isArray(title)
        ? title.map((line) => <span key={line}>{line}</span>)
        : title;

    return (
        <div className={c.cardWrap}>
            {saveLabel && <span className={c.saveBadge}>{saveLabel}</span>}
            <div className={clsx(c.card, recommended && c.cardRecommended)} data-tier={tier}>
                {voucherCode && (
                    <div className={clsx(c.voucherApplied, packageListVariant && c.voucherAppliedPackageList)}>
                        <svg width="16" height="16" viewBox="0 0 16 16">
                            <circle cx="8" cy="8" r="8" fill="#22C55E" />
                            <path d="M5 8l2 2 4-4" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className={c.voucherText}>{appliedLabel}</span>
                    </div>
                )}
                <h3 className={c.title}>{titleContent}</h3>
                {originalPrice && <div className={c.priceOriginal}>{originalPrice}</div>}
                <div className={c.priceRow}>
                    <span className={c.priceMain}>{price}</span>
                    <span className={c.priceUnit}>{priceUnit}</span>
                </div>
                {nextBilling && (
                    <div className={c.nextBilling}>{nextBilling}</div>
                )}
                <ul className={c.benefitList}>
                    {benefits.map((b, i) => {
                        const benefitText = typeof b === "string" ? b : b && b.text;
                        const excluded = !!(b && b.excluded);
                        if (!benefitText) return null;
                        return (
                            <li key={`${benefitText}-${i}`} className={c.benefitItem}>
                                <span className={c.benefitIcon}>
                                    {excluded ? <XIcon /> : <CheckIcon />}
                                </span>
                                <span>{benefitText}</span>
                            </li>
                        );
                    })}
                </ul>
                <button
                    type="button"
                    className={clsx(c.cta, shouldUsePrimaryCta && c.ctaRecommended)}
                    onClick={onChoose}
                >
                    {ctaLabel}
                </button>
            </div>
        </div>
    );
};

export default PremiumLitePlanCard;
